const getAlphanumericText = (value: string) => (
  value.replace(/[\W_]+/g,'')
);

export default getAlphanumericText;